import React from "react";
import LineupHeader from "../LineupHeader/LineupHeader";
import LineupSubHeader from "../LineupSubHeader/LineupSubHeader";
import SingleLineupSmallComponent from "./SingleLineupSmallComponent/SingleLineupSmallComponent";
import "./LineupHome.css";
import { getStatsColumnMapping } from "../../utils/columnsJsonInformation";
import { connect } from "react-redux";
import { setGeneratedLineupCount } from "../../redux/Lineup/LineupAction";
import { getUserId } from "../../utils/utils";
import TagManager from "react-gtm-module";
import AppJS from "../../assets/app/AppJS";
import AppCSS from "../../assets/app/AppCSS";
import { getID } from "../../firebase";

function LineupHome(props) {
  console.log("Lineup Home:: ", props.location.state);

  if (
    props.location.state == undefined ||
    props.location.state == null ||
    props.location.state == ""
  ) {
    window.location.href = "/";
  }

  let noOfLineups;
  let lineupData;
  let myLineups;
  let recommendationLineups;
  let pathArray = window.location.pathname.split("/");
  let pathLength = pathArray.length - 1;
  let pathCheck = pathArray[pathLength];
  console.log("My Lineups Flag:: ", props.location.state);
  if (
    (!props.location.state.hasOwnProperty("myLineups") &&
      pathCheck === "mylineups") ||
    props.location.state.myLineups === true
  ) {
    noOfLineups = props.location.state.data.length;
    lineupData = props.location.state.data;
    myLineups = props.location.state.myLineups;
    recommendationLineups = props.location.state.recommendationLineups;
    console.log("My Lineup Data:: ", lineupData);
  } else if (
    props.location.state.recommendationLineups === true ||
    pathCheck === "recommendations"
  ) {
    noOfLineups = props.location.state.data.data.length;
    lineupData = props.location.state.data.data;
    myLineups = props.location.state.myLineups;
    recommendationLineups = props.location.state.recommendationLineups;
    console.log("Recommendation Lineup Data:: ", lineupData);
  } else {
    console.log("Not MY LINEUPS");
    noOfLineups = props.location.state.data.data.length;
    lineupData = props.location.state.data.data;
    myLineups = props.location.state.myLineups;
    recommendationLineups = props.location.state.recommendationLineups;
    lineupData["optimizer"] = props.optimizer;
    console.log("NML", noOfLineups, lineupData, myLineups);
  }

  const [savedAllLineups, setSavedAllLineups] = React.useState(false);

  React.useEffect(async () => {
    if (props.location.state.myLineups === true || pathCheck === "mylineups") {
      document.title = "My Lineups";
    } else if (
      props.location.state.recommendationLineups === true ||
      pathCheck === "recommendations"
    ) {
      document.title = "Spontasy Lineups | Recommendations";
    } else {
      document.title = "Spontasy Lineups";
    }
    props.update_generated_lineup_count(noOfLineups);
    if (noOfLineups === props.lineup_state.saved_lineup_count) {
      setSavedAllLineups(true);
    }

    const userId = getID();
    if (process.env.REACT_APP_ENV === "production") {
      TagManager.dataLayer({
        dataLayer: {
          event: "pageview",
          userId: userId,
        },
      });
    }
  }, [props.lineup_state.saved_lineup_count]);

  const getDisplayNameOptimizer = (actualName) => {
    // if myLineups is true then every card should have independent optimizer
    if (props.location.state.myLineups === true) {
      return actualName;
    } else {
      if (props.league != null) {
        const requiredColumn = getStatsColumnMapping(
          props.league,
          props.remoteConfig
        ).filter((column) => column.actual_name == actualName);
        console.log("display name", actualName, requiredColumn);
        return requiredColumn[0].display_name;
      }
    }
  };

  console.log("Lineup Data", lineupData, "Type", typeof lineupData);

  const optimizer = getDisplayNameOptimizer(
    props.location.state.data.optimizer
  );

  console.log("Optimizer", optimizer);
  return (
    <>
      <AppJS />
      <AppCSS />
      <LineupHeader
        lineupData={lineupData}
        optimizer={optimizer}
        generated_lineup_count={noOfLineups}
        myLineups={myLineups}
        className="bg-dark"
      />
      <LineupSubHeader
        myLineups={myLineups}
        className="bg-dark"
        remoteConfig={props.remoteConfig}
      />
      <div class="text-center w-100 border-bottom text-white border-secondary mb-1 bg-dark text-white">
        {typeof lineupData !== "string" ? `${noOfLineups}` : 0} lineups
      </div>

      <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-sm-2 row-cols-xl-3 bg-dark">
        {typeof lineupData !== "string" ? (
          lineupData.map((singleLineup, index) => (
            <div class="col mb-2" key={index}>
              <SingleLineupSmallComponent
                singleLineup={singleLineup}
                optimizer={
                  myLineups === true || recommendationLineups == true
                    ? singleLineup.optimizer
                    : optimizer
                }
                className="bg-light"
                savedAllLineupsFlag={savedAllLineups}
                index={index}
                myLineups={myLineups}
                recommendationLineups={recommendationLineups}
                remoteConfig={props.remoteConfig}
              />
            </div>
          ))
        ) : (
          <></>
        )}
      </div>
      {/* To Check if optimizer is valid or not! */}
      {typeof lineupData === "string" ? (
        <div className="d-flex justify-content-center bg-dark ">
          <h3 className="text-secondary pt-5">{lineupData}</h3>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    lineup_state: state.lineupReducer,
    league: state.gameInformationReducer.sports,
    remoteConfig: state.rcReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    update_generated_lineup_count: (value) =>
      dispatch(setGeneratedLineupCount(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LineupHome);
